import { Button, Dropdown, HorizontalDivider, Icon, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { paths } from '@hero/routes/paths';
import { useGeneralStore } from '@hero/store/hooks';

import * as S from './style';

const SidebarHelp = ({ isSidebarOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showLearningCenterTooltip, setShowLearningCenterTooltip } = useGeneralStore();

  const salesNumber = t('salesNumber');

  const learningCenterVideos = t('learningCenterVideos', { returnObjects: true });
  const hasLearningCenterVideo = !!learningCenterVideos?.length;
  if (!salesNumber && !hasLearningCenterVideo) return null;

  return (
    <>
      <Dropdown
        popperOptions={{
          placement: 'right',
          strategy: 'fixed',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-72, -28]
              }
            }
          ]
        }}
        isMenuOpenDefault={showLearningCenterTooltip}
        style={{ width: '100%' }}
        popperStyles={{ zIndex: 20, width: 260 }}
        referenceComponent={() => (
          <S.SidebarHelp
            onClick={() => {
              navigate(paths.LEARNING_CENTER);
            }}
            isSidebarOpen={isSidebarOpen}
            isActive={showLearningCenterTooltip}
          >
            <Icon name="f-faq" className="question-icon" size="lg" />

            {isSidebarOpen && <Typography variant="caption1Bold">{t('learningCenter')}</Typography>}

            <S.SidebarHelpContent>
              <S.SidebarHelpContentBody>
                <Typography variant="caption1Bold">{t('needHelp')}</Typography>
                {salesNumber && (
                  <a href={`tel:${salesNumber}`} onClick={e => e.stopPropagation()}>
                    <Button variant="link" startIcon={<Icon name="phone" size="md" />}>
                      {salesNumber}
                    </Button>
                  </a>
                )}
                {t('sendUsAnEmail') && (
                  <a href={`mailto:${t('mailTo')}`} onClick={e => e.stopPropagation()}>
                    <Button variant="link" startIcon={<Icon name="email" size="md" />}>
                      {t('sendUsAnEmail')}
                    </Button>
                  </a>
                )}
              </S.SidebarHelpContentBody>
            </S.SidebarHelpContent>
          </S.SidebarHelp>
        )}
      >
        {() => {
          return (
            <S.SidebarHelpTooltip>
              <Typography variant="body2Bold">{t('needHelpGettingStarted')}</Typography>
              <Typography variant="body2">
                <Trans i18nKey="visitLearningCenterForGuides" components={{ b: <b /> }} />
              </Typography>

              <HorizontalDivider $margin="16px 0" />

              <Button
                onClick={() => {
                  setShowLearningCenterTooltip(false);
                }}
                size="sm"
                block
              >
                {t('okay')}
              </Button>
            </S.SidebarHelpTooltip>
          );
        }}
      </Dropdown>
      {showLearningCenterTooltip && (
        <S.DropdownBackdrop
          onClick={() => {
            setShowLearningCenterTooltip(false);
          }}
        />
      )}
    </>
  );
};

SidebarHelp.propTypes = {
  isSidebarOpen: PropTypes.bool
};

export default SidebarHelp;
